import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import RecordCount from "../../assets/SharedComponents/RecordCount/RecordCount";
import { Tooltip } from "@mui/material";
import { ThreeDots } from "react-loader-spinner";
import { Wrapper } from "./style/style";
import { confirmAlert } from "react-confirm-alert";
import API from "../../api/axios";
import { APP_URLS } from "../../api/url";
import { APIError } from "../../core/utils";
import { FaFilterIcon } from "../../assets/Images/icon";
import NoRecord from "../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../assets/SharedComponents/Pagination";
import { Link, useLocation } from "react-router-dom";
import CountryFilter from "../../assets/SharedComponents/Filters/CountryFilter";
import SearchKey from "../../assets/SharedComponents/Search/SearchKey";
import FPJSDataPreview from "./Components/FPJSData";
import RemoveData from "./Components/RemoveData";
import { suggestionText } from '../../config/constant';

const FlaggedData = () => {

  const userAccess = JSON.parse(localStorage.getItem("permissions"));

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [flaggedData, _flaggedData] = useState([]);
  const [page, setPage] = useState(Number(searchParams.get("page") || 1));
  const [total, _total] = useState(0);
  const [totalPage, _totalPage] = useState(0);

  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [ip, setIp] = useState("");
  const [filters, _filters] = useState(false);

  const [countValue, _countValue] = useState(
    Number(searchParams.get("per_page") || 10)
  );

  const [flaggedDataLoader, _flaggedDataLoader] = useState(false);
  const [actionloader, _actionloader] = useState(false);

  const [scamMessages, _scamMessages] = useState([]);
  const [flagLabel, _flagLabels] = useState({})


  const scammerManagement = useMemo(
    () => userAccess.find((o) => o.slug === "scammer_users_management"),
    [userAccess]
  );

  const canDeleteReportedUsers = useMemo(() => {
    return scammerManagement?.permissions?.some((perm) => perm.slug === "delete");
  }, [scammerManagement]);

  useEffect(() => {
    getReportedUsers();
  }, [page, countValue, country, email, phone, ip]);

  const getReportedUsers = () => {
    _flaggedDataLoader(true);
    API.get(
      `${APP_URLS.LIST_FLAGGED_USERS}?page=${page}&per_page=${countValue}&filter[country_id]=${country}&filter[phone]=${phone}&filter[email]=${email}&filter[ip]=${ip}`
    )
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _flaggedData(resp.data.data);
          _total(resp.data.total);
          _totalPage(resp.data.last_page);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => {
        _flaggedDataLoader(false);
      });
  };

  useEffect(() => {
    _flaggedDataLoader(true);
    API.get(
      `${APP_URLS.LIST_SUGGESTION_TEXT}?limited_data=true&filter[type]=${suggestionText.BLOCKED_CHAT_MESSAGES}&with_trashed=0`
    )
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _scamMessages(resp.data.items);
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch((error) => {
        toast.error(APIError(error), { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => {
        _flaggedDataLoader(false);
      });
  }, []);

  // Fetch Flag labels
  useEffect(() => {
    if (flagLabel && Object.keys(flagLabel).length > 0) return

    (async () => {
      try {
        const res = await API.get(
          `${APP_URLS.FRAUD_SETTINGS}/labels`
        );
        const { data: resp } = res;
        if (resp.success) {
          _flagLabels(resp?.data?.items ?? {})
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      } catch (error) {
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    })()

  }, [])

  const handleCountry = (item) => {
    setCountry(item);
    _totalPage(0);
    setPage(1);
  };

  const handleEmail = (item) => {
    setEmail(item);
    _totalPage(0);
    setPage(1);
  };

  const handlePhone = (item) => {
    setPhone(item);
    _totalPage(0);
    setPage(1);
  };

  const handleIp = (item) => {
    setIp(item);
    _totalPage(0);
    setPage(1);
  };


  const handleChange = (searchValue) => {
    _countValue(searchValue);
    _totalPage(0);
    setPage(1);
  };

  //removing all filters
  const clearFilter = () => {
    _filters(true);
    setEmail('')
    setPhone('')
    setCountry('')
    setIp('')
    _countValue(10);
    _totalPage(0);
    setPage(1);
  };

  const handleAction = (userId, isScammer) => {
    if (actionloader) return;
    confirmAlert({
      title: `Confirm to ${isScammer ? "uncensor" : "unflag"}`,
      message: `Are you sure you want to perform this action?`,
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            _actionloader(true);
            API.delete(`${APP_URLS.LIST_FLAGGED_USERS}/${userId}`)
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  toast.success(`Action has been taken successfully`, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  getReportedUsers();
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch(function (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              })
              .finally(() => {
                _actionloader(false);
              });
          },
        },
        { label: "No" },
      ],
    });
  };

  return (
    <>
      <Wrapper>
        <div className="auctionMainContainer">
          <div className="row mt-4">
            <div className="col-md-12 text-align-center">
              <h1>FLAGGED DATA</h1>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
            <div className="justify-content-end mt-1 me-2">
              <span className="text-start">
                Total Records : <b>{total}</b>
              </span>
            </div>
            <div className="justify-content-end mt-4 d-flex gap-2 mb-2 select-info align-items-center">
              <CountryFilter value={country} handleChange={handleCountry} />
              <SearchKey
                onSearchClick={(search) =>
                  handleEmail(search)
                }
                id="searchData"
                placeholder="Search by Email"
                val={email}
                filters={filters}
                _filters={_filters}
              />
              <SearchKey
                onSearchClick={(search) =>
                  handlePhone(search)
                }
                id="searchData"
                placeholder="Search by Phone"
                val={phone}
                filters={filters}
                _filters={_filters}
              />
              <SearchKey
                onSearchClick={(search) =>
                  handleIp(search)
                }
                id="searchData"
                placeholder="Search by IP Address"
                val={ip}
                filters={filters}
                _filters={_filters}
              />
              <RecordCount
                onSearchClick={(search) => handleChange(search)}
                id="pageCount"
                val={countValue}
                filters={filters}
                _filters={_filters}
              />
              <Tooltip title="Clear Filter" placement="bottom">
                <FaFilterIcon
                  className="filter-icon"
                  role="button"
                  onClick={clearFilter}
                />
              </Tooltip>
            </div>
          </div>
          <div className="tableContainer">
            <table className="auctionTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Country</th>
                  <th>Risk Score</th>
                  <th>FPJS Data</th>
                  <th>Action</th>
                </tr>
              </thead>
              {flaggedDataLoader ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {flaggedData.length > 0 ? (
                    flaggedData.map(({ id: flaggedId, user }) => {
                      const { id, pseudo, limited_address = {}, risk_points, phone, email, is_flagged, is_scammer } = user || {};
                      const { prefix_call, flag_thumbnail, fullname } = limited_address || {};

                      return (
                        <tr className="table-row" key={`reported-user-${flaggedId}`}>
                          <td>{flaggedId ?? '-'}</td>
                          <td className="name-tags-container">
                            <Link to={`/detail-member/${id}`} className="user-profile-link" target="_blank">
                              <span className="user-name">{pseudo ?? '-'}</span>
                              <span className="user-id">({id ?? '-'})</span>
                            </Link>
                            {(is_flagged || is_scammer) ?
                              <div className="scammer-tags">
                                {is_flagged ? <span className="flagged">Flagged</span> : null}
                                {is_scammer ? <span className="scammer">Scammer</span> : null}
                              </div>
                              : null
                            }
                          </td>
                          <td>{email ?? '-'}</td>
                          <td>{phone ? `${prefix_call} ${phone}` : '-'}</td>
                          <td>
                            {flag_thumbnail ? (
                              <img
                                src={flag_thumbnail}
                                alt=""
                                className="countryflag"
                                title={fullname}
                              />
                            ) : (
                              '-'
                            )}
                          </td>
                          <td>{risk_points ?? '-'}</td>
                          <td>
                            <FPJSDataPreview id={id} flagLabel={flagLabel} />
                          </td>
                          <td>
                            {canDeleteReportedUsers && (is_flagged || is_scammer) ? (
                              <div className="action">

                                <button
                                  className="reject"
                                  onClick={() => handleAction(flaggedId, is_scammer)}
                                  disabled={actionloader}
                                >
                                  {(is_flagged && is_scammer) ? "Uncensor" : ""}
                                  {(is_flagged && !is_scammer) ? "Unflag" : ""}
                                </button>

                                {is_scammer ?
                                  <RemoveData
                                    flaggedId={flaggedId}
                                    actionloader={actionloader}
                                    _actionloader={_actionloader}
                                    getReportedUsers={getReportedUsers}
                                    scamMessages={scamMessages}
                                  />
                                  : null
                                }
                              </div>
                            )
                              : null
                            }
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>

              )}
            </table >
          </div >
          <div>
            {totalPage > 1 ? (
              <Pagination
                totalPages={totalPage}
                page={page}
                key={totalPage}
                onPageClick={(page) => setPage(page + 1)}
              />
            ) : (
              ""
            )}
          </div>
        </div >
      </Wrapper >
    </>
  );
};

export default FlaggedData;
